(ns common.schema.entities.asset
  (:require
   [common.country :as country]
   [common.schema.constraints :as constraints]
   [common.schema.entity-type-names-base :as entity-type-names-base]
   [common.schema.assets :as assets]
   [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/text-edn-field
    ;; {:lat 21.23423 :long 32.23423}
    :asset/coordinates
    "Coordinates"
    {:authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/tag-industry "Industry" {})
   [[:asset/name
     {:field/data-type             :data.type/text-simple
      :field/default-ord           10
      :field/name-attribute        :asset/name
      :field/mandatory             :mandatory/always
      :field/system-required?      true
      :field/system-semantics      su/user-provided-system-required-field-semantics
      :field/default-visibility    {:editor :editor.type/link
                                    :edit   :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :in-use-disabled}
      :field/lower-case-str?       true
      :field/not-clearable?        true
      :field/constraints           {:constraint/string-min-length         1
                                    :constraint/unique-tenant-ignore-case
                                    {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                             :asset/name
                                                             assets/all-asset-types)}}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Name"}}]

    [:asset/description
     {:field/data-type          :data.type/text-multiline
      :field/default-ord        40
      :field/default-visibility {:editor :editor.type/textarea
                                 :grid   :editor.type/textarea
                                 :filter :filter.type/text
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Description"}}]

    [:asset/type
     ;; TODO: remove this is a hock to promote multiple asset types in front end
     {:field/data-type :data.type/keyword
      :field/default-ord 25
      :value-type :keyword
      :options (->> assets/target-asset-type-mappings
                    (map (fn [[parent-entity asset-types]]
                           asset-types))
                    (flatten)
                    (distinct)
                    (map (fn [at]
                           {:key   at
                            :label (->> at
                                        entity-type-names-base/base-entities
                                        :field/translations
                                        :en)})))
      :field/default-visibility {:editor :editor.type/none
                                 :grid   :editor.type/none
                                 :filter :filter.type/text
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-buy-side
                                    :access/write :role/user}
      :field/hidden-from-configuration? true
      :disabled? true
      :field/not-clearable? true
      :field/not-importable? true
      :field/translations {:en "Select asset type"}
      :field/label-icon :fa-lock
      :field/label-icon-tooltip
      "Multiple asset types are supported in\r\nEnterprise edition. Please contact\r\nsales@Zapflow.com for details"}]
    [:asset/fax-number
     {:field/data-type          :data.type/text-simple
      :field/default-ord        26
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Fax number"}}]
    [:asset/location
     {:field/data-type          :data.type/text-simple
      :field/default-ord        70
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Location"}}]

    [:asset/country
     {:field/data-type    :data.type/keyword-multi
      :field/default-ord  35
      :value-type         :keyword
      :field/default-visibility {:editor :editor.type/multi-select
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :options            country/options
      :field/translations {:en "Country"}}]
    [:asset/county
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "County"}}]
    [:asset/state
     {:field/data-type          :data.type/text-simple
      :field/default-ord        60
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "State"}}]
    [:asset/city
     {:field/data-type          :data.type/text-simple
      :field/default-ord        70
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "City"}}]
    [:asset/zip-code
     {:field/data-type          :data.type/text-simple
      :field/default-ord        70
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Zip code"}}]
    [:asset/street-address
     {:field/data-type             :data.type/text-simple
      :field/default-ord           80
      :field/constraints           {:constraint/string-max-length 160}
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Street address"}}]
    [:asset/street-address-2
     {:field/data-type             :data.type/text-simple
      :field/default-ord           81
      :field/constraints           {:constraint/string-max-length 160}
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Street address line 2"}}]
    [:asset/street-address-3
     {:field/data-type             :data.type/text-simple
      :field/default-ord           82
      :field/constraints           {:constraint/string-max-length 160}
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Street address line 3"}}]
    [:asset/street-address-4
     {:field/data-type             :data.type/text-simple
      :field/default-ord           83
      :field/constraints           {:constraint/string-max-length 160}
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Street address line 4"}}]]
   (su/text-simple-field :asset/other-address-street
                         "Other Street Address"
                         {:default-field-visibility :not-in-use
                          :authorization su/access-ssg-ssg})
   (su/text-simple-field :asset/other-address-city
                         "Other Address City"
                         {:default-field-visibility :not-in-use
                          :authorization su/access-ssg-ssg})
   (su/text-simple-field :asset/other-address-state
                         "Other Address State"
                         {:default-field-visibility :not-in-use
                          :authorization su/access-ssg-ssg})
   (su/keyword-field :asset/other-address-country-code
                     "Other Address Country"
                     country/options
                     {:default-field-visibility :not-in-use
                      :authorization su/access-ssg-ssg})
   (su/text-simple-field :asset/other-address-zipcode
                         "Other Address ZipCode"
                         {:default-field-visibility :not-in-use
                          :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/j-lab-or-funded-partner
                          "J-Lab or funded partner"
                          {:default-field-visibility :not-in-use-blocked
                           :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/project-investigator
                          "Project investigator"
                          {:default-field-visibility :not-in-use-blocked
                           :authorization su/access-ssg-ssg})
   (su/integer-field :asset/year-project-funded
                     "Year project funded"
                     {:default-field-visibility :not-in-use
                      :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/program-type
                          "Program type"
                          {:default-field-visibility :not-in-use
                           :authorization su/access-ssg-ssg})
   (su/text-simple-field :asset/research-period
                         "Research period"
                         {:default-field-visibility :not-in-use
                          :authorization su/access-ssg-ssg})
   (su/currency-field :asset/cur-grant-amount
                      "Grant amount"
                      {:default-field-visibility :not-in-use-blocked
                       :authorization su/access-ssg-ssg})
   (su/text-multiline-field :asset/project-description
                            "Project description"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/cj-lead
                          "CJ Lead"
                          {:default-field-visibility :not-in-use-blocked
                           :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/alj-lead
                          "ALJ Lead"
                          {:default-field-visibility :not-in-use-blocked
                           :authorization su/access-ssg-ssg})
   (su/text-multiline-field :asset/project-update
                            "Project update"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/date-field :asset/date-of-project-update
                  "Date of project update"
                  {:default-field-visibility :not-in-use
                   :authorization su/access-ssg-ssg})
   (su/option-field :asset/project-status
                    "Project status"
                    {:default-field-visibility :not-in-use
                     :authorization su/access-ssg-ssg})
   (su/option-field-multi :asset/faculty
                          "Faculty"
                          {:default-field-visibility :not-in-use-blocked
                           :authorization su/access-ssg-ssg})))
